import instance from "../Config/Config";

export const ADD_WISHLIST = "add_to_wishlist";
export const GET_WISHLIST = "wishlist";
export const REMOVE_WISHLIST = "remove_wishlist";
export const REMOVE_ALL_WISHLIST = "remove_all_wishlist";
export const MOVE_TO_CART = "move_to_cart";
export const MOVE_ALL_TO_CART = "move_all_to_cart";
export const CHECK_WISHLIST = "check_wishlist";

export const AddtoWishlist_fun = async (productId) => {
    const response = await instance.post(ADD_WISHLIST, { product_id: productId }, {
        headers: { "Content-Type": "application/json" }
    });
    return response?.data;
};

export const GetWishlist_fun = async () => {
    const response = await instance.get(GET_WISHLIST);
    return response?.data;
};

export const RemoveWishlist_fun = async (productId) => {
    const response = await instance.delete(REMOVE_WISHLIST, {
        data: { product_id: productId },
        headers: { "Content-Type": "application/json" }
    });
    return response?.data;
};

export const RemoveAllWishlist_fun = async () => {
    const response = await instance.delete(REMOVE_ALL_WISHLIST, {
        headers: { "Content-Type": "application/json" }
    });
    return response?.data;
};

export const MoveToCart_fun = async (productId) => {
    const response = await instance.post(MOVE_TO_CART, { product_id: productId }, {
        headers: { "Content-Type": "application/json" }
    });
    return response?.data;
};

export const MoveAllToCart_fun = async () => {
    const response = await instance.post(MOVE_ALL_TO_CART, {}, {
        headers: { "Content-Type": "application/json" }
    });
    return response?.data;
};

export const CheckWishlist_fun = async (productId) => {
    const response = await instance.post(CHECK_WISHLIST, { product_id: productId }, {
        headers: { "Content-Type": "application/json" }
    });
    return response?.data;
};
